<span class="cyc-mixing-dots" (dblclick)="log()">
  <span class="cyc-mixing-dots__line"></span>
  @for (stage of mixingEvent()?.speedPattern; let i = $index; track i) {
    <span
      class="cyc-mixing-dot"
      [class.cyc-mixing-dot--preparing]="mixingEvent()?.status === 'preparing'"
      [class.cyc-mixing-dot--in-progress]="
        mixingEvent()?.status === 'in_progress' &&
        (stage.status === 'preparing' || stage.status === 'in_progress')
      "
      [class.cyc-mixing-dot--fail]="
        mixingEvent()?.status === 'fail' &&
        (stage.status === 'preparing' || stage.status === 'in_progress')
      "
      [class.cyc-mixing-dot--complete]="stage.status === 'complete'"
    ></span>
  }
</span>
